export const CRATE_BARCODES = ["8721184771907", "8721184771914", "8721184771921"];

export const CRATES = [
  { size: "s", name: "Doos Small CF", barcode: "8721184771907", dimensions: { width: 38.5, depth: 29, height: 17 } },
  { size: "m", name: "Doos Medium CF", barcode: "8721184771914", dimensions: { width: 38.5, depth: 29, height: 39 } },
  { size: "l", name: "Doos Large CF", barcode: "8721184771921", dimensions: { width: 58.5, depth: 38.5, height: 39 } },
];
